import { UNIT_BOX, UNIT_DOZEN, UNIT_PACKET, UNIT_PIECE } from "./common";
import type { PackDef } from "./types";

/** "Library" in Bangladesh: a shop selling books and stationery, not a lending library. */
export const BOOKSHOP_PACK: PackDef = {
  id: "library",
  version: 1,
  available: true,
  name: { en: "Library (books & stationery)", bn: "লাইব্রেরি (বই ও স্টেশনারি)" },
  description: {
    en: "Shops selling textbooks, guide books, novels and stationery",
    bn: "পাঠ্যবই, গাইড বই, উপন্যাস ও স্টেশনারি বিক্রির দোকান",
  },
  icon: "library",
  modules: {
    variants: false,
    batches: false,
    expiry: false,
    serials: false,
    vat: false,
    multi_branch: false,
    storefront: false,
    loans: false,
  },
  baseUnits: [
    UNIT_PIECE,
    { code: "copy", name: { en: "Copy", bn: "কপি" }, fractional: false },
    { code: "set", name: { en: "Set", bn: "সেট" }, fractional: false },
    { code: "ream", name: { en: "Ream", bn: "রিম" }, fractional: false },
    UNIT_DOZEN,
    UNIT_PACKET,
    UNIT_BOX,
  ],
  unitConversions: [{ from: "dz", to: "pc", factor: 12 }],
  categories: [
    { en: "Textbooks (NCTB)", bn: "পাঠ্যবই (এনসিটিবি)" },
    { en: "Guide & help books", bn: "গাইড ও সহায়ক বই" },
    { en: "Admission & job preparation", bn: "ভর্তি ও চাকরি প্রস্তুতি" },
    { en: "University & professional", bn: "বিশ্ববিদ্যালয় ও পেশাগত" },
    { en: "Novels & literature", bn: "উপন্যাস ও সাহিত্য" },
    { en: "Islamic books", bn: "ইসলামিক বই" },
    { en: "Children's books", bn: "শিশুদের বই" },
    { en: "Exercise books & paper", bn: "খাতা ও কাগজ" },
    { en: "Pens & pencils", bn: "কলম ও পেন্সিল" },
    { en: "Art & craft", bn: "আর্ট ও ক্রাফট" },
    { en: "Office supplies", bn: "অফিস সামগ্রী" },
  ],
  customFields: [
    {
      key: "author",
      entity: "item",
      type: "text",
      label: { en: "Author / writer", bn: "লেখক" },
      required: false,
      searchable: true,
    },
    {
      key: "publisher",
      entity: "item",
      type: "text",
      label: { en: "Publisher", bn: "প্রকাশনী" },
      required: false,
      searchable: true,
    },
    {
      key: "edition",
      entity: "item",
      type: "text",
      label: { en: "Edition / year", bn: "সংস্করণ / সাল" },
      required: false,
      searchable: true,
    },
    {
      key: "class",
      entity: "item",
      type: "select",
      label: { en: "Class", bn: "শ্রেণি" },
      required: false,
      searchable: true,
      options: [
        { value: "class_1", label: { en: "Class 1", bn: "প্রথম শ্রেণি" } },
        { value: "class_2", label: { en: "Class 2", bn: "দ্বিতীয় শ্রেণি" } },
        { value: "class_3", label: { en: "Class 3", bn: "তৃতীয় শ্রেণি" } },
        { value: "class_4", label: { en: "Class 4", bn: "চতুর্থ শ্রেণি" } },
        { value: "class_5", label: { en: "Class 5", bn: "পঞ্চম শ্রেণি" } },
        { value: "class_6", label: { en: "Class 6", bn: "ষষ্ঠ শ্রেণি" } },
        { value: "class_7", label: { en: "Class 7", bn: "সপ্তম শ্রেণি" } },
        { value: "class_8", label: { en: "Class 8", bn: "অষ্টম শ্রেণি" } },
        { value: "class_9", label: { en: "Class 9", bn: "নবম শ্রেণি" } },
        { value: "class_10", label: { en: "Class 10", bn: "দশম শ্রেণি" } },
        { value: "hsc", label: { en: "HSC (11–12)", bn: "এইচএসসি (একাদশ–দ্বাদশ)" } },
        { value: "honours", label: { en: "Honours / degree", bn: "অনার্স / ডিগ্রি" } },
        { value: "other", label: { en: "Other", bn: "অন্যান্য" } },
      ],
    },
    {
      key: "isbn",
      entity: "item",
      type: "text",
      label: { en: "ISBN", bn: "আইএসবিএন" },
      required: false,
      searchable: true,
    },
    {
      key: "rack",
      entity: "item",
      type: "text",
      label: { en: "Rack / shelf", bn: "র‍্যাক / তাক" },
      required: false,
      searchable: true,
    },
  ],
  receiptTemplate: "retail",
  dashboard: [
    "sales_today",
    "gross_profit",
    "cash_in_hand",
    "dues_receivable",
    "dues_payable",
    "low_stock",
    "sales_trend",
  ],
};
